(function () {
    'use strict';

    angular.module('app.core', [
        /*
         * Angular modules
         */
        'ngAnimate', 'ngCookies', 'ngRoute', 'ngResource',
        /*
         * Reusable cross app code modules
         */
        'adtServices', 'adtFilters', 'adtDirectives',
        /*
         * 3rd Party modules
         */
        'angularModalService', 'ui-rangeSlider', 'ui.bootstrap.pagination', 'ngclipboard'
    ]);
})();